import React, { useEffect, useState } from 'react';
import { Shield, Car, Plane, Gift, Home, Star, PenLine } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../context/AuthContext';

const PRO_TYPES = ['commitment', 'no_escape'];

const ICONS = { shield: Shield, car: Car, plane: Plane, gift: Gift, home: Home, star: Star };

export function TemplatePicker({ selectedId, onPick }) {
  const { user } = useAuth();
  const isPremium = user?.tier === 'premium' || user?.role === 'admin';
  const [data, setData] = useState({ builtin: [], mine: [] });
  useEffect(() => { api.get('/templates').then((r) => setData(r.data)).catch(() => {}); }, []);
  const all = [...data.mine, ...data.builtin];
  if (all.length === 0) return null;
  const chip = (t) => {
    const Icon = ICONS[t.icon] || Star;
    const active = selectedId === t.template_id;
    return (
      <button key={t.template_id} type="button" data-testid={`template-chip-${t.template_id}`} onClick={() => onPick(!isPremium && PRO_TYPES.includes(t.vault_type) ? { ...t, vault_type: 'basic' } : t)}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs font-semibold transition-colors duration-200 ${active ? 'bg-[#9333EA] border-[#9333EA] text-white' : 'border-white/10 text-[#A19DB0] hover:text-white hover:border-[#9333EA]/50'}`}>
        <Icon className="h-3.5 w-3.5" />{t.name}{!isPremium && PRO_TYPES.includes(t.vault_type) && <span className="text-[9px] text-amber-400" title="Premium lock strength — you'll get a Basic vault">PRO</span>}
      </button>
    );
  };
  return (
    <div data-testid="template-picker" className="space-y-2">
      <p className="text-[10px] uppercase tracking-widest text-[#A19DB0] font-semibold">Start from a template — or type your own</p>
      <div className="flex flex-wrap gap-2">
        <button type="button" data-testid="template-chip-blank" onClick={() => onPick(null)}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs font-semibold transition-colors duration-200 ${!selectedId ? 'bg-white/10 border-white/30 text-white' : 'border-white/10 text-[#A19DB0] hover:text-white'}`}>
          <PenLine className="h-3.5 w-3.5" />Blank
        </button>
        {all.map(chip)}
      </div>
    </div>
  );
}
